import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, Truck } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Field } from "../../components/Common";
import PublicFrame from "./PublicFrame";

export default function SupplierOrder() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [f, setF] = useState({ tracking_number: "", carrier: "", tracking_url: "" });
  const [error, setError] = useState("");
  const load = () => api.get(`/public/supplier-order/${token}`).then((r) => { setD(r.data); setF((x) => ({ ...x, tracking_number: r.data.tracking_number || "", carrier: r.data.carrier || "" })); }).catch((e) => setError(errMsg(e)));
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return <PublicFrame><p data-testid="supplier-order-error">{error || "…"}</p></PublicFrame>;
  const save = async () => { setError(""); try { await api.post(`/public/supplier-order/${token}`, f); load(); } catch (e) { setError(errMsg(e)); } };
  return (
    <PublicFrame branding={d.branding}>
      <div className="space-y-6" data-testid="supplier-order">
        <div><p className="text-xs uppercase tracking-[0.18em] text-muted-foreground flex items-center gap-2"><Truck className="h-3.5 w-3.5" />Drop-ship order</p>
          <h1 className="text-3xl font-bold">{d.order_number}</h1></div>
        <div className="rounded-[var(--radius)] border bg-card p-5 text-sm space-y-1">
          {d.items.map((i, k) => <div key={k}>{i.qty}× {i.name} {i.sku && <span className="text-muted-foreground">· {i.sku}</span>}</div>)}
          <p className="pt-2 text-muted-foreground">Ship to: {Object.values(d.ship_to).filter(Boolean).join(", ")}</p>
        </div>
        {d.status === "shipped" && <div className="flex items-center gap-2 rounded-[var(--radius)] border border-emerald-500/30 bg-emerald-500/10 p-4 text-emerald-800 text-sm" data-testid="supplier-order-shipped"><CheckCircle2 className="h-4 w-4" />Marked as shipped · {d.tracking_number}</div>}
        <div className="grid sm:grid-cols-3 gap-3">
          <Field label="Tracking number"><Input data-testid="supplier-tracking-input" value={f.tracking_number} onChange={(e) => setF({ ...f, tracking_number: e.target.value })} /></Field>
          <Field label="Carrier"><Input data-testid="supplier-carrier-input" placeholder="Royal Mail, DPD…" value={f.carrier} onChange={(e) => setF({ ...f, carrier: e.target.value })} /></Field>
          <Field label="Tracking link (optional)"><Input data-testid="supplier-tracking-url-input" placeholder="https://" value={f.tracking_url} onChange={(e) => setF({ ...f, tracking_url: e.target.value })} /></Field>
        </div>
        {error && <p className="text-sm text-destructive">{error}</p>}
        <Button className="rounded-full" data-testid="supplier-tracking-save-btn" disabled={f.tracking_number.trim().length < 3} onClick={save}>Save tracking & notify customer</Button>
      </div>
    </PublicFrame>
  );
}
